<template>
  <div class="form-group lm-select mb-0" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
    >
      {{label}} <small v-if="required">*</small>

      <font-awesome-icon
        icon="question-circle"
        size="sm"
        class="clickable float-right mt-1 ml-2"
        v-if="help"
        v-b-tooltip.hover="help"
      />
    </label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
    />
    <b-form-group>
      <b-form-radio-group
        v-model="data"
        :options="options"
        @input="$emit('input', $event)"
        :size="size"
        :stacked="isVertical"
        :buttons="variant === 'button'"
        :button-variant="buttonsClass"
        :disabled="disabled"
      >
      </b-form-radio-group>
    </b-form-group>
    <p class="invalid-feedback d-block" v-if="'required' in v && !v.required && v.$dirty">{{ $t('field_required')}} </p>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  data () {
    return {}
  },
  computed: {
    data: {
      get () {
        return this.value
      },
      set (val) {}
    }
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    /**
    * Radio options
    */
    options: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'md'
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'radio'
    },
    buttonsClass: {
      type: String,
      default: ''
    }
  }
}
</script>
